import React from 'react';
import PropTypes from 'prop-types';
import { FDBodyText, FDStack, FDSlider } from '@facet-wealth/design';


function PicklistValueSlider(props) {
  const {
    value,
    onChange,
    readonly,
    options: metaOptions,
  } = props;

  const selectedOption = metaOptions.find(option => option.id === value);
  const displayValue = selectedOption ? selectedOption.prompt : '';

  const sliderOptionsByValue = metaOptions.reduce((optionsMap, option, index) => ({
    ...optionsMap,
    [option.id]: index,
  }), {});

  const sliderValue = sliderOptionsByValue[value] || 0;

  function handleChange(idx) {
    onChange(metaOptions[idx].id);
  }

  return (
    <FDStack direction={'column'} justifyContent={'center'} spacing={1}>
      <FDBodyText value={displayValue} size={'lg'} />
      <FDSlider
        min={0}
        max={metaOptions.length - 1}
        value={sliderValue}
        onChange={handleChange}
        disabled={readonly}
        label={'risk-tolerance'}
      />
    </FDStack>
  );
}

PicklistValueSlider.propTypes = {
  value: PropTypes.string.isRequired,
  readonly: PropTypes.bool.isRequired,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default PicklistValueSlider;
